module.exports = __webpack_public_path__ + "img/62e85ef.svg";